// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2boqI","notes":"Notes_notes__I6icZ"};